import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Checkbox } from './ui/checkbox';

const TermsAccordion = ({ variant = 'talent', agreed, onAgreeChange, showError }) => {
  const [expanded, setExpanded] = useState(false);

  const talentTerms = [
    'You consent to CultureCareers collecting and storing your personal information, including your resume and portfolio, to match you with relevant opportunities.',
    'Your profile may be shared with employers, recruiters, or collaborators for the purpose of job matching.',
    'CultureCareers does not guarantee job placement, interviews, or responses from employers.',
    'You are responsible for ensuring that the information you provide is accurate and up to date.',
    'CultureCareers is not liable for any employment decisions, offers, or interactions between you and third parties.',
    'You may request removal of your data at any time.'
  ];

  const employerTerms = [
    'CultureCareers provides a platform to publish opportunities and does not guarantee applications, hires, or outcomes.',
    'All listings are subject to review. We reserve the right to approve, reject, or remove any listing.',
    'You are responsible for the accuracy, authenticity, and legality of the information provided.',
    'Any payment made is for listing visibility and distribution, not for guaranteed results.',
    'CultureCareers is not liable for hiring decisions, candidate interactions, or employment outcomes.',
    'Payments are non-refundable once a listing has been published.'
  ];

  const terms = variant === 'talent' ? talentTerms : employerTerms;
  const title = variant === 'talent' ? 'Talent Terms & Conditions' : 'Employer Terms & Conditions';

  return (
    <div data-testid={`terms-accordion-${variant}`}>
      <div
        className="rounded-xl overflow-hidden"
        style={{ border: '1px solid #F0EBE2' }}
      >
        {/* Accordion trigger */}
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className="w-full flex items-center justify-between px-5 py-4 text-left transition-colors"
          style={{ backgroundColor: expanded ? '#F0EBE2' : '#FFFFFF' }}
          data-testid={`terms-toggle-${variant}`}
        >
          <span className="text-sm font-medium" style={{ color: '#0F2942' }}>
            View Terms & Conditions
          </span>
          <ChevronDown
            className="w-4 h-4 transition-transform duration-300"
            style={{
              color: '#D4820A',
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)'
            }}
            strokeWidth={2}
          />
        </button>

        {/* Expandable content */}
        <div
          className="overflow-hidden transition-all duration-300 ease-in-out"
          style={{
            maxHeight: expanded ? '600px' : '0px',
            opacity: expanded ? 1 : 0
          }}
        >
          <div className="px-5 pb-5" style={{ borderTop: '1px solid #F0EBE2' }}>
            <div className="pt-4">
              <h4
                className="text-lg font-normal tracking-tight mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif', color: '#0F2942' }}
              >
                {title}
              </h4>
              <p className="text-xs mb-4" style={{ color: '#0F2942' }}>
                By submitting your details, you agree to the following:
              </p>
              <ul className="space-y-3">
                {terms.map((term, i) => (
                  <li key={i} className="flex items-start gap-2.5">
                    <span className="w-1 h-1 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#D4820A' }} />
                    <span className="text-sm leading-relaxed" style={{ color: '#0F2942' }}>{term}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Checkbox */}
      <div className="mt-4 flex items-start gap-2.5">
        <Checkbox
          id={`terms-agree-${variant}`}
          checked={agreed}
          onCheckedChange={onAgreeChange}
          className="mt-0.5"
          data-testid={`terms-checkbox-${variant}`}
        />
        <label
          htmlFor={`terms-agree-${variant}`}
          className="text-sm cursor-pointer"
          style={{ color: '#0F2942' }}
        >
          I agree to the Terms & Conditions
        </label>
      </div>
      {showError && !agreed && (
        <p className="text-xs mt-1.5 ml-6" style={{ color: '#D4820A' }} data-testid={`terms-error-${variant}`}>
          Please accept the Terms & Conditions to continue
        </p>
      )}
    </div>
  );
};

export default TermsAccordion;
